import isDevelopment from "helpers/isDevelopment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default (...names: string[]): object => {
    const dictionary = useSelector((state: any) => state.dictionary.translations);
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        if (dictionary && names && names.length > 0) {
            const result = JSON.parse(JSON.stringify(translations));

            if (names && names.length > 0) {
                names.forEach((name: string) => {
                    result[name] = dictionary[name] ?? (isDevelopment() ? name : "");
                });
            }

            setTranslations(result);
        }
    }, [dictionary]);

    if (names && names.length > 0) {
        return translations;
    } else {
        return dictionary;
    }
};
